import React from "react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

export default function Impressum() {
  const owner = "Mehmet Kuruçam";
  const address = "Pontstraße 101, 52062 Aachen";
  const phone = "+49 176 56198464";
  const phoneDigits = phone.replace(/\D/g, "");
  const email = "leukasumzug@gmail.com";
  const emailLink = <a href={`mailto:${email}`} className="text-brand-amberDark">{email}</a>;

  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="text-xs font-bold uppercase tracking-widest text-brand-amberDark">Rechtliches</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-heading font-bold text-slate-900">Impressum</h1>

        <div className="mt-8 space-y-6 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-heading font-semibold text-slate-900 mb-3">Angaben gemäß § 5 DDG</h2>
            <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-1.5">
              <div><span className="font-semibold">Firma:</span> Leukas Umzug Service</div>
              <div><span className="font-semibold">Inhaber:</span> {owner}</div>
              <div><span className="font-semibold">Adresse:</span> {address}</div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-slate-900 mb-3">Kontakt</h2>
            <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-1.5">
              <div><span className="font-semibold">Telefon:</span> <a href={`tel:+${phoneDigits}`} className="text-brand-amberDark">{phone}</a></div>
              <div><span className="font-semibold">WhatsApp:</span> <a href={`https://wa.me/${phoneDigits}`} className="text-brand-amberDark">{phone}</a></div>
              <div><span className="font-semibold">E-Mail:</span> {emailLink}</div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-slate-900 mb-3">Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)</h2>
            <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-1.5">
              <div><span className="font-semibold">Name:</span> {owner}</div>
              <div><span className="font-semibold">Adresse:</span> {address}</div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-slate-900 mb-2">Haftungsausschluss</h2>
            <p>
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
              externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
              verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-slate-900 mb-2">Streitschlichtung</h2>
            <p>
              Plattform der EU-Kommission zur Online-Streitbeilegung:{" "}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-brand-amberDark">https://ec.europa.eu/consumers/odr</a>.
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
